'use client';

import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';
import { cn } from '@/utils/tailwind-merge';

const BracketText = ({ label, className }: { label: string; className?: string }) => {
    const [ref, isVisible] = useIntersectionObserver({ threshold: 0.8 });

    return (
        <div ref={ref} className={cn('relative flex items-end text-white', className)}>
            <span
                className={cn(
                    'transition-transform duration-1000 ease-in-out text-[larger]',
                    isVisible ? 'transform translate-x-[0]' : '-translate-x-[100%]',
                )}
            >
                {'['}
            </span>
            <span className="relative px-2">{label}</span>
            <span
                className={cn(
                    'transition-transform duration-1000 ease-in-out text-[larger]',
                    isVisible ? 'transform translate-x-[0]' : 'translate-x-[100%]',
                )}
            >
                {']'}
            </span>
        </div>
    );
};

export default BracketText;
